"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6245],{

/***/ 6245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ ContactUsHome; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
// import ButtonArrow from "../reusable/ButtonArrow";
// export default function ContactUsHome() {
//   return (
//     <section className="relative h-[30vh] md:h-[30vh] w-full bg-gradient-to-b from-white to-gray-200">
//       <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
//         <h1 className="text-4xl sm:text-6xl  text-black">
//           How can we help you?
//           {/* Careers */}
//         </h1>
//         <ButtonArrow 
//           txt="Contact us"
//           link="/contact-us"
//           style="w-[170px] text-black hover:no-underline text-lg font-medium"
//           className="text-center"
//         />
//       </div>
//     </section>
//   );
// }
// import Link from "next/link";
// export default function ContactUsHome() {
//     return (
//       <div className="w-full bg-gradient-to-t from-amber-50 to-white ">
//         <div className="max-w-3xl mx-auto px-4 text-center">
//           <h2 className="text-3xl font-bold text-gray-800 mb-4">
//             Ready to Transform Your Business?
//           </h2>
//           <p className="text-lg text-gray-600 mb-8">
//           Join industry leaders who've already discovered how our solutions can drive growth. Our team is ready to create your custom solution to give you a competitive edge.
//           </p>
//           <div className="mb-8">
//             <a 
//               href="/contact-us"
//               className="inline-block group relative overflow-hidden rounded-lg bg-amber-600 px-8 py-4 text-white transform transition-all duration-300 hover:scale-105 hover:shadow-xl"
//             >
//               <span className="relative z-10 text-lg font-semibold">
//               Schedule Your Consultation
//               </span>
//               <div className="absolute inset-0 bg-gradient-to-r from-amber-500 to-amber-700 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></div>
//             </a>
//           </div>
//         </div>
//       </div>
//     )
//   }


function ContactUsHome() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full bg-gradient-to-t from-amber-50 to-white mt-8",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-3xl mx-auto pb-7 px-4 text-center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "text-3xl font-bold text-gray-800 mb-4",
                    children: "Ready to Transform Your Business?"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "text-lg text-gray-600 mb-8",
                    children: [
                        "Join industry leaders already scaling with our",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/services/custom-software-development",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "text-amber-700 font-medium hover:underline",
                                children: "custom software solutions"
                            })
                        }),
                        ". Let’s build the tools your business needs to grow faster and stay ahead."
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "py-5",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/contact-us",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                            className: "inline-block group relative overflow-hidden rounded-lg bg-amber-600 px-8 py-4 text-white transform transition-all duration-300 hover:scale-105 hover:shadow-xl",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "relative z-10 text-lg font-semibold",
                                    children: "Schedule Your Consultation"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "absolute inset-0 bg-gradient-to-r from-amber-500 to-amber-700 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};


/***/ })

}]);